import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
const DesktopDevPageSideVideoSide = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['DesktopDevPageSideVideoSide'], safety, {
        format: 'video-nc',
        video: {},
        skipBidders: [
            'google'
        ]
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopDevPageSideVideoSide.displayName = 'DesktopDevPageSideVideoSide';
export default DesktopDevPageSideVideoSide;
